module.exports = __webpack_public_path__ + "static/media/credit_card.68b7f947.png";